import { ROW_STATE_LABELS, errorText } from './labels';
import { type GridRow, rowState } from './pending';

interface MobileUnitListProps {
  readonly rows: readonly GridRow[];
  readonly canEditStored: boolean;
  readonly onEdit: (row: GridRow) => void;
}

/** Phone layout: readable cards instead of a wide spreadsheet. Editing opens a form. */
export function MobileUnitList({ rows, canEditStored, onEdit }: MobileUnitListProps) {
  const visible = rows.filter((row) => rowState(row) !== 'placeholder');
  return (
    <ul className="unit-cards" aria-label="רשימת יחידות">
      {visible.map((row) => {
        const state = rowState(row);
        const errors = Object.entries(row.errors);
        const editable = row.unitId === null || canEditStored;
        return (
          <li
            key={row.key}
            className={`unit-card unit-card--${errors.length > 0 ? 'error' : state}`}
          >
            <div className="unit-card__head">
              <strong>{row.cells.code || 'יחידה חדשה'}</strong>
              <span className={`chip chip--${errors.length > 0 ? 'error' : state}`}>
                {errors.length > 0 ? 'שגיאה' : ROW_STATE_LABELS[state]}
              </span>
            </div>
            <p className="unit-card__meta">
              {row.cells.kind} · מספר {row.cells.displayNumber || '—'} · בניין{' '}
              {row.cells.building || '—'} · קומה {row.cells.floor || '—'}
            </p>
            {errors.length > 0 && (
              <p className="field__error">
                {errors.map(([field, code]) => errorText(field, code)).join(' · ')}
              </p>
            )}
            {editable && (
              <button
                type="button"
                className="button button--small"
                onClick={() => {
                  onEdit(row);
                }}
              >
                עריכה
                <span className="visually-hidden"> של יחידה {row.cells.code}</span>
              </button>
            )}
          </li>
        );
      })}
    </ul>
  );
}
